/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import priceDetail from '../child/priceDetail/index';
import editPayPerson from '../child/editPayPerson';
import dateFormat from '@/tools/dateFormat';
import {
  listPayOrderExportZip,
  orderPeopleInfoDownload,
  orderManagement,
  paymentReview
} from '@/api/ajax';
import payAmount from '../components/payAmount.vue';
import { moneyFixed } from '@/tools/money.js';
import receiptDownload from '@/page/settlementCenter/utils/receiptDownload.js';
import { proxyData } from '@/page/settlementCenter/utils';
import { MessageBox, Message } from 'element-ui';
import { PAY_BANK_TYPE_KEY } from '@/common/constants/bank';
import { payStatusIcon } from '@/common/fields/order';

const PARTIAL_PAYMENT_SUCCESSFUL = '部分支付成功';
const PAYMENT_IN_PROGRESS = '支付中';

const btnLoading = proxyData({
  value: false
});

const orderPeopleInfoDownloadFunc = async (
  vm,
  csoCustomOrderIds,
  isPay = 0,
  payPassagewayCode
) => {
  btnLoading.value = true;
  try {
    await vm.$downloadFile(
      `${orderPeopleInfoDownload}?csoCustomOrderIds=${csoCustomOrderIds}&isPay=${isPay}&payPassagewayCode=${payPassagewayCode}`,
      true,
      '',
      'post'
    );
  } catch (e) {
    console.error(e);
  }
  btnLoading.value = false;
};

const download = async (csoCustomOrderIds, priceType, orderNo, isPay = 0) => {
  receiptDownload(
    {
      ids: csoCustomOrderIds,
      priceType: priceTypeMap[priceType],
      isPay
    },
    listPayOrderExportZip,
    'ids',
    `${orderNo}`
  );
};

const getStatusName = (
  cantPay,
  payStatus,
  authStatus,
  gongyeAuditStatus,
  priceType
) => {
  // 审核状态优先级最高 authStatus 1审核中 3审核不通过
  if (cantPay) {
    return '无法支付';
  }
  if (authStatus === 3 || gongyeAuditStatus === 3) {
    return '支付失败';
  } else if (
    authStatus === 1 ||
    (gongyeAuditStatus === 1 && payStatus === 0) ||
    (gongyeAuditStatus === 2 && payStatus === 0 && authStatus !== 3)
  ) {
    return '支付中';
  } else {
    return getPayStatusTextMap(priceType)[payStatus];
  }
};
/**
 * 支付进度  展示逻辑
 */
// function paymentTransition(a, b) {
//   return `${a}/${b}`;
// }
/**
 * @description: 获取对应类型的支付状态文字
 * @param {number} type 当前订单类型 1组合 2 3 4
 * @return {string}
 */
export const getPayStatusTextMap = (type = 0) => {
  return type <= 1
    ? ['待支付', '支付中', PARTIAL_PAYMENT_SUCCESSFUL, '支付成功', '支付失败']
    : ['待支付', '支付中', '支付成功', '支付失败'];
};
export const priceTypeMap = {
  1: 22, // 项目费用
  2: 32, // 平台服务费
  3: 33, // 杂费
  4: 34, // 综合服务费
  6: 210 // 商务服务费
};
/**
 * @description: 根据不同状态，生成本次需打款字段
 * @param {Number} type 自定义字段，在弹层组件中使用 1未支付(又分为1全部未支付和2部分支付) 3已支付 4失效
 * @param {String} label 列表显示名称与弹层title
 * @return {Object}
 */
export const createTotalPayment = (type, label = '本次需打款总金额', key) => {
  return {
    label,
    prop: 'orderPrice',
    width: '200px',
    render: function(h, ctx, r) {
      // 全部未支付类型，支付状态为已支付则为2
      const _type = type === 1 && r.payStatus === 2 ? 2 : type;
      const showDialog = () => {
        // 根据rowData中的priceType使用对应组件
        const pathMapping = {
          1: 'priceDetail',
          2: 'orderServiceFee',
          3: 'otherFee',
          4: 'universeServiceFee',
          6: 'busServiceOrder'
        };
        ctx.parent.$xrkDialog({
          title: label,
          width: '90vw',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: ctx.parent._c(
              require(`../child/${pathMapping[r.priceType]}/index`).default,
              {
                props: {
                  csoCustomOrderIds: r.csoCustomOrderIds,
                  orderId: r.id,
                  type: _type,
                  fullInfo: r,
                  userEnterpriseType: r.userEnterpriseType
                }
              }
            )
          }
        });
      };

      let price = moneyFixed(r.currentPayAmount || r.orderPrice);

      if (key) price = moneyFixed(r[key]);

      return (
        <div class="orderPrice">
          <el-link icon="" type="primary" onClick={showDialog}>
            {/* currentPayAmount 是对部分支付成功后的需打款金额 */}
            {/* {(r.discountPrice !== 0 && r.priceType !==2 && r.priceType !== 3)?moneyFixed(r.initOrderPrice):moneyFixed(r.currentPayAmount || r.orderPrice)} */}
            {price}
          </el-link>
          {r.discountPrice !== 0 && ![2, 3, 6].includes(r.priceType) && (
            <el-popover
              trigger="hover"
              placement="right"
              style={{ width: '200px', height: '50px' }}
            >
              <div style={{ width: '200px', height: '50px' }}>
                <div>应付：{moneyFixed(r.initOrderPrice)}</div>
                <div>优惠：{moneyFixed(r.discountPrice)}</div>
                <div>实付：{moneyFixed(r.orderPrice)}</div>
              </div>
              <img
                slot="reference"
                src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                style={{ width: '50px', height: '15px' }}
              />
            </el-popover>
          )}
        </div>
      );
    }
  };
};

/**
 * @description: 原有订单总金额抽离处理，改成方法，增加取值动态传参
 * @param {*} key
 * @returns {*}
 */
export const createCurrentPayAmount = key => {
  return {
    label: '本次需打款总金额',
    prop: 'orderPrice',
    width: '200px',
    render: function(h, ctx, r) {
      // 待支付部分打款金额优先使用currentPayAmount，其他使用orderPrice
      let price = moneyFixed(r.currentPayAmount || r.orderPrice);

      if (key) price = moneyFixed(r[key]);

      return (
        <div class="orderPrice">
          <span>{price}</span>
        </div>
      );
    }
  };
};

export const reMark = () => {
  return {
    label: '备注',
    width: '200px',
    render: function(h, ctx, r) {
      let vm = ctx.parent;
      let type = Number(vm.activeIndex) + 1;
      let handRemark = async () => {
        let param = {
          orderSn: r.orderSn,
          priceType: r.priceType,
          platformRemark: vm.searchQuery.platformRemark,
          projectName: vm.searchQuery.projectName,
          type: type
        };
        vm.$xrkDialog({
          title: '查看批次',
          showConfirm: false,
          showCancel: false,
          $slots: {
            default: vm.$createElement(require('../child/remark').default, {
              props: {
                param
              }
            })
          }
        });
      };
      return r.priceType == 1 || r.priceType == 2 || r.priceType == 6 ? (
        <el-button type="text" onClick={handRemark}>
          查看批次
        </el-button>
      ) : (
        <span>{r.platformRemark}</span>
      );
    }
  };
};

export default {
  selection: {
    type: 'selection',
    width: '40px',
    reserve: true
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName',
    width: '200px'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  industryName1: {
    label: '企业名称',
    prop: 'industryName',
    width: '200px'
  },
  supplierName: {
    label: '供应商',
    prop: 'supplierName',
    width: '200px'
  },
  taskAmount: {
    label: '金额',
    prop: 'taskAmount'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo',
    width: '200px'
  },
  batchOrderNo: {
    label: '批次编号',
    prop: 'batchOrderNo',
    width: '200px'
  },
  sumPayCount: {
    label: '项目人员',
    prop: 'sumPayCount'
  },
  industryName: {
    label: '工业方',
    prop: 'industryName',
    width: '200px'
  },
  pagMentpayDt: {
    label: '提交审核时间',
    prop: 'aspAuditApplyDt',
    formatter(row) {
      return dateFormat(row.aspAuditApplyDt) || '-';
    },
    width: '180px'
  },
  aspAuditDt: {
    label: '审核时间',
    prop: 'aspAuditDt',
    formatter(row) {
      return dateFormat(row.aspAuditDt) || '-';
    },
    width: '140px'
  },
  payLane: {
    prop: 'payPassagewayName',
    label: '支付通道'
  },
  auditStatus: {
    prop: 'aspAuditStatus',
    label: '审核状态',
    width: '140px',
    render: function(h, ctx, r) {
      return (
        <div>
          {
            <span>
              {['审核中', '审核通过', '审核不通过'][r.aspAuditStatus - 1]}
            </span>
          }
          {r.aspAuditStatus === 3 && (
            <el-popover trigger="hover" placement="top-start">
              <div style="max-width: 300px">
                <p>原因：</p>
                {r.aspAuditReason}
              </div>
              <i
                slot="reference"
                class="el-icon-warning"
                style="color:#E6A23C"
              ></i>
            </el-popover>
          )}
        </div>
      );
    }
  },
  daizhifudingdanshengchengshijian: {
    label: '订单生成时间', //待支付
    prop: 'createDt',
    width: '180px',
    formatter(row) {
      return dateFormat(row.createDt);
    }
  },
  zhifujiezhishijian: {
    label: '支付截止时间',
    prop: 'orderEndPayDt',
    width: '140px'
  },
  zhifuSumPrice: {
    label: '支付总金额',
    prop: 'orderPrice',
    width: '200px',
    showToolTip: false,
    render: function(h, ctx, r) {
      let currentPrice = moneyFixed(r.orderPrice);
      const showDialog = () => {
        ctx.parent.$xrkDialog({
          title: '打款总金额',
          width: '90vw',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: ctx.parent.$createElement(payAmount, {
              props: {
                id: r.id,
                paySUm: currentPrice
              }
            })
          }
        });
      };
      return (
        <div class="orderPrice" style="display:flex;align-items:center">
          <el-tooltip
            class="item"
            effect="dark"
            content={currentPrice}
            placement="top"
          >
            <span class="ellipsis" style="width: 120px;text-align:right">
              {currentPrice}
            </span>
          </el-tooltip>
          <el-link style="margin-left:8px" type="primary" onClick={showDialog}>
            {'详情'}
          </el-link>
        </div>
      );
    }
  },
  dingdanzongjine: {
    label: '订单总金额',
    prop: 'orderPriceTotal',
    width: '200px',
    render: function(h, ctx, r) {
      const showDialog = () => {
        ctx.parent.$xrkDialog({
          title: '订单总金额',
          width: '90vw',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: ctx.parent._c(priceDetail, {
              props: {
                orderId: r.id,
                payStatus: r.payStatus,
                userEnterpriseType: r.userEnterpriseType
              }
            })
          }
        });
      };

      let parentName = ctx.parent.$parent.$options.name;
      let isToPay = parentName === 'toPayOrder'; // 如果是前往支付
      // 待支付部分打款金额优先使用currentPayAmount，其他使用orderPrice
      // let currentPrice = moneyFixed(r.currentPayAmount || r.orderPrice);
      let currentPrice = moneyFixed(r.currentPayAmount || r.orderPrice);
      return (
        <div class="orderPrice">
          {isToPay ? (
            <span>{currentPrice}</span>
          ) : (
            <el-link type="primary" onClick={showDialog}>
              {currentPrice}
            </el-link>
          )}

          {!!r.discountPrice && (
            <el-popover
              trigger="hover"
              placement="right"
              style={{ width: '200px', height: '50px' }}
            >
              <div style={{ width: '200px', height: '50px' }}>
                <div>应付：{moneyFixed(r.initOrderPrice)}</div>
                <div>优惠：{moneyFixed(r.discountPrice)}</div>
                <div>实付：{moneyFixed(r.orderPrice)}</div>
              </div>
              <img
                slot="reference"
                src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                style={{ width: '50px', height: '15px' }}
              />
            </el-popover>
          )}
        </div>
      );
    }
  },
  bencixudakuanzongjine: createCurrentPayAmount(),
  feeType: {
    label: '费用类型',
    prop: 'priceType',
    width: '120px',
    formatter: value => {
      const vmap = {
        1: '项目费用',
        2: '平台服务费',
        3: '杂费',
        4: '综合服务费',
        6: '商务服务费'
      };
      return vmap[value.priceType];
    }
  },
  remark: {
    label: '备注',
    prop: 'platformRemark',
    width: '140px'
  },
  _paymentProgress: {
    label: '支付进度', //支付成功/总支付人数
    render: (h, ctx, r) => h('div', `${r.successPayCount}/${r.sumPayCount}`)
  },
  zhifuzhuangtai: {
    width: '140px',
    label: '支付状态',
    prop: 'payStatus',
    render: (h, ctx, r) => {
      const cantPay = r.payStatus == 5;

      return (
        <div>
          <span>
            {getStatusName(
              cantPay,
              r.payStatus,
              r.authStatus,
              r.gongyeAuditStatus,
              r.priceType
            )}
          </span>
          {payStatusIcon(h, ctx, r)}
          {cantPay && (
            <el-tooltip
              class="item"
              effect="dark"
              content="该订单下有自然人已退出项目结算，请等待平台修改优惠金额后再支付！"
              placement="top"
            >
              <i
                class="el-icon-question"
                style="color:#46a6ff;margin-left:3px;font-size: 18px;transform: translateY(1px);"
              ></i>
            </el-tooltip>
          )}
        </div>
      );
    }
  },
  operation: {
    label: '操作',
    width: '260px',
    render: function(h, ctx, row) {
      const vm = ctx.parent;
      // 关闭支付、线下支付完成的订单
      const isCloseOrrgType =
        !!+row.closeOrRgType && [1, 2].includes(+row.closeOrRgStatus);
      // 有优惠，支付中，审核中，审核通过 都不可修改
      const disabled =
        !!row.discountPrice ||
        row.payStatus === 1 ||
        [1, 2].includes(row.authStatus) ||
        row.gongyeAuditStatus === 1 ||
        isCloseOrrgType;
      const showDialog = () => {
        vm.$xrkDialog.call(vm, {
          title: '修改',
          width: '90vw',
          // top:'5vh',
          $slots: {
            default: h(editPayPerson, {
              props: {
                row
              },
              on: {
                confirm: ({ _ctx, needDelOrderId }) => {
                  // 项目列表-修改 || 批次-修改-项目人员修改 层级较深
                  try {
                    if (needDelOrderId) {
                      _ctx.elTableRef.store.states.selection = _ctx.elTableRef.store.states.selection.filter(
                        item => {
                          return item.id !== needDelOrderId;
                        }
                      );
                      _ctx.elTableRef.toggleRowSelection(
                        _ctx.elTableRef.store.states.selection,
                        false
                      );
                    }
                    // 重新计算总金额
                    _ctx.getSelectionOrders();
                  } catch (e) {
                    console.error(e);
                  }
                  // 刷新层列表
                  vm.saveSuccess();
                }
              }
            }),
            footer: h('div', { style: { display: 'none' } })
          }
        });
      };
      const {
        csoCustomOrderIds,
        batchOrderNo,
        orderNo,
        priceType,
        revokeStatus,
        authLink,
        authStatus
      } = row;
      const payStatusText = getStatusName(
        row.payStatus == 5,
        row.payStatus,
        row.authStatus,
        row.gongyeAuditStatus,
        row.priceType
      );
      /*
        展示下载支付详情逻辑
        1：支付状态为【部分支付成功】并且费用类型为【项目费用】
        2：支付状态为【支付中】并且支付通道为网银线下支付
      */
      const showDownloadDisabled1 =
        priceType === 1 && payStatusText === PARTIAL_PAYMENT_SUCCESSFUL;
      // showDownloadDisabled2 状态为true则修改不展示，下载支付详情展示
      const showDownloadDisabled2 =
        priceType === 1 &&
        row[PAY_BANK_TYPE_KEY] === 'offLineBank' &&
        payStatusText === PAYMENT_IN_PROGRESS;

      const showDownload = showDownloadDisabled1 || showDownloadDisabled2;
      // 下载支付详情按钮禁用状态; 一级审核通过, 二级待审核 (后端提供的表达式)
      const downloadBtnDisabled =
        revokeStatus == 2 ||
        !(
          (authLink == 1 && authStatus == 2) ||
          (authLink == 2 && authStatus !== 3)
        );
      return (
        <div>
          {!showDownloadDisabled2 && (
            <el-button type="text" onClick={showDialog} disabled={disabled}>
              修改
            </el-button>
          )}
          {showDownload && (
            <el-button
              type="text"
              loading={btnLoading.value}
              onClick={() =>
                orderPeopleInfoDownloadFunc(
                  vm,
                  csoCustomOrderIds,
                  0,
                  row.payPassagewayCode
                )
              }
              disabled={downloadBtnDisabled}
            >
              下载支付详情
            </el-button>
          )}
          {showDownloadDisabled1 && (
            <el-button
              type="text"
              onClick={() =>
                download(csoCustomOrderIds, priceType, batchOrderNo || orderNo)
              }
              disabled={revokeStatus == 2}
            >
              下载回单
            </el-button>
          )}
        </div>
      );
    }
  },
  auditOperation: {
    width: 120,
    showToolTip: false,
    label: '操作',
    render: function(h, ctx, row) {
      const vm = ctx.parent;
      const passAudit = () => {
        MessageBox.confirm('确定通过审核?', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false
        }).then(async () => {
          await paymentReview.audit({
            id: row.id,
            aspAuditStatus: 2
          });
          Message.success('操作成功');
          vm.reGetPage && vm.reGetPage();
        });
      };
      const showDialog = () => {
        vm.$xrkDialog({
          title: '审核不通过',
          showConfirm: false,
          showCancel: false,
          $slots: {
            default: vm.$createElement(
              require('../components/auditFail').default,
              {
                props: {
                  id: row.id
                },
                on: {
                  success: () => {
                    vm.reGetPage && vm.reGetPage();
                  }
                }
              }
            )
          }
        });
      };
      return (
        <div>
          <el-button
            onClick={() => {
              passAudit();
            }}
            type="text"
          >
            通过
          </el-button>
          <el-button onClick={showDialog} type="text">
            不通过
          </el-button>
        </div>
      );
    }
  },
  batchOperation: {
    label: '操作',
    width: '260px',
    render: function(h, ctx, row) {
      const vm = ctx.parent;

      // 有优惠，支付中，审核中，审核通过，无csoCustomOrderIds 都不可修改
      const disabled =
        !!row.discountPrice ||
        row.payStatus === 1 ||
        [1, 2].includes(row.authStatus) ||
        row.gongyeAuditStatus === 1 ||
        row.priceType !== 1 ||
        !row.csoCustomOrderIds;
      const showDialog = () => {
        vm.$xrkDialog.call(vm, {
          title: '修改',
          width: '90vw',
          'show-close': false,
          // top:'5vh',
          $slots: {
            default: h(require('../child/editPayProject.vue').default, {
              props: {
                row
              },
              on: {
                confirm: () => {
                  // 重新计算总金额
                  vm.$parent.getSelectionOrders();
                  // 刷新层列表
                  vm.saveSuccess();
                }
              }
            }),
            footer: h('div', { style: { display: 'none' } })
          }
        });
      };
      const showDownload = row.batchPayStatus == 2;
      // showDownloadDisabled 状态为true则修改不展示，下载支付详情展示
      const payStatusText = getStatusName(
        row.payStatus == 5,
        row.payStatus,
        row.authStatus,
        row.gongyeAuditStatus,
        row.priceType
      );
      const showDownloadDisabled =
        row.priceType === 1 &&
        row[PAY_BANK_TYPE_KEY] === 'offLineBank' &&
        payStatusText === PAYMENT_IN_PROGRESS;
      //下载支付详情按钮禁用状态
      const showDownloadDetail =
        row.batchPayStatus == 2 || showDownloadDisabled;

      const downDeailBtnDesFn = () => {
        if (row.payPassagewayCode !== 'offLineBank') {
          return row.revokeStatus == 2;
        } else {
          return !(
            (row.authLink == 1 && row.authStatus == 2) ||
            (row.authLink == 2 && row.authStatus !== 3) ||
            (row.authLink == 3 && row.authStatus !== 3)
          );
        }
      };
      const downDeailBtnDes = downDeailBtnDesFn();
      return (
        <div>
          {!showDownloadDisabled && (
            <el-button type="text" onClick={showDialog} disabled={disabled}>
              修改
            </el-button>
          )}
          {showDownloadDetail && (
            <el-button
              type="text"
              loading={btnLoading.value}
              onClick={() =>
                orderPeopleInfoDownloadFunc(
                  vm,
                  row.csoCustomOrderIds,
                  0,
                  row.payPassagewayCode
                )
              }
              disabled={downDeailBtnDes}
            >
              下载支付详情
            </el-button>
          )}
          {showDownload && (
            <el-button
              type="text"
              onClick={() =>
                download(
                  row.csoCustomOrderIds,
                  row.priceType,
                  row.batchOrderNo || row.orderNo
                )
              }
              disabled={row.revokeStatus == 2}
            >
              下载回单
            </el-button>
          )}
        </div>
      );
    }
  },
  yingfu: {
    label: '应付',
    prop: 'yingfu'
  },
  shifu: {
    label: '实付',
    prop: 'shifu'
  },
  youhui: {
    label: '优惠',
    prop: 'youhui'
  },
  dingdanshengchengshijian: {
    label: '订单生成时间',
    prop: 'createDt',
    width: '180px'
  },
  // totalPrice: {
  // 	label: '本次需打款总金额',
  // 	prop: 'totalPrice'
  // },

  // 支付状态单独判断
  payStatus: {
    label: '支付状态',
    prop: 'payStatus', //支付状态  0 未支付(默认) 1 支付中 2 部分支付成功 3 支付成功 4 支付失败
    width: '140px',
    render: function(h, ctx, r, c) {
      let map = getPayStatusTextMap(r.priceType);
      let rowV = r[c.property];
      return h('div', map[rowV]);
    }
  },
  // 已支付订单
  finishOperation: {
    label: '操作',
    prop: 'finishOperation',
    width: '260px',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const { id, orderNo, priceType, batchOrderNo, csoCustomOrderIds } = row;
      const payDetail = () => {
        const targetID = {
          1: { csoCustomOrderIds: csoCustomOrderIds + '' },
          2: { csoOrderServicesIds: id },
          3: { authOrderIds: id },
          4: { comprehensiveOrderIds: id },
          6: { csoBusServicesIds: id }
        };

        vm.$xrkDialog({
          title: '支付记录',
          showConfirm: false,
          showCancel: false,
          $slots: {
            default: vm.$createElement(require('../child/orderPay').default, {
              props: {
                ...targetID[priceType],
                // orderNo,
                needDownload: true
              }
            })
          }
        });
      };
      // 退出结算的审核状态
      const { revokeStatus } = row;
      return (
        <div>
          <el-button
            type="text"
            onClick={payDetail}
            disabled={revokeStatus == 2}
          >
            支付记录
          </el-button>
          {priceType === 1 && (
            <el-button
              type="text"
              loading={btnLoading.value}
              onClick={() =>
                orderPeopleInfoDownloadFunc(
                  vm,
                  csoCustomOrderIds,
                  1,
                  row.payPassagewayCode
                )
              }
              disabled={revokeStatus == 2}
            >
              下载支付详情
            </el-button>
          )}
          {
            <el-button
              type="text"
              onClick={() =>
                download(
                  csoCustomOrderIds,
                  priceType,
                  batchOrderNo || orderNo,
                  1
                )
              }
              disabled={revokeStatus == 2}
            >
              下载回单
            </el-button>
          }
        </div>
      );
    }
  },
  rebuildOperation: {
    label: '操作',
    prop: 'finishOperation',
    width: '180px',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const rebuild = async () => {
        // TODO: 批量的需要传入多个订单id，逗号分割
        let csoCustomOrderIds = (row.csoCustomOrderIds || row.id) + '';
        await orderManagement.rebuildOrder({
          payCsoCustomOrderIds: csoCustomOrderIds
        });
        vm.$message({
          type: 'success',
          message: '重新生成成功'
        });
        vm.saveSuccess();
      };
      return (
        <div>
          <el-button type="text" onClick={rebuild}>
            重新生成订单
          </el-button>
        </div>
      );
    }
  },
  xiangmucanyuren: {
    label: '项目参与人',
    prop: 'fullName'
  }
};
